/**
 * Legal notice — EN (courtesy translation). The French version prevails.
 */
export const legalEn = {
  eyebrow: 'Legal documents',
  title: 'Legal notice',
  subtitle:
    "Information about the publisher of the openmeta.tech website, its hosting and contact details, in accordance with Article 6-III of French Act No. 2004-575 of 21 June 2004 for Confidence in the Digital Economy (LCEN).",
  updated: '8 September 2026',
  seoTitle: 'Legal notice — OpenMeta',
  seoDescription:
    "Legal notice of the openmeta.tech website: publisher, registered office, share capital, registration, VAT, host, contact.",
  sections: [
    {
      id: 'publisher',
      title: 'Website publisher',
      blocks: [
        {
          type: 'p',
          content:
            "The openmeta.tech website is published by OPENMETA, a French simplified joint-stock company (SAS) with share capital of €40,000.",
        },
        {
          type: 'ul',
          content: [
            'Registered office: 5037 Chemin de la Veillotière, 61330 Ceaucé, France.',
            'Alençon Trade and Companies Register: 978 390 813.',
            'European identification number: FR6101.978390813.',
            'Phone: +33 2 59 16 64 45.',
            'Email: support@openmeta.fr.',
          ],
        },
      ],
    },
    {
      id: 'director',
      title: 'Publication director',
      blocks: [
        {
          type: 'p',
          content: 'The publication director is the legal representative of OPENMETA.',
        },
      ],
    },
    {
      id: 'host',
      title: 'Hosting',
      blocks: [
        {
          type: 'p',
          content:
            'Hosting: OVH SAS — 2 rue Kellermann, 59100 Roubaix, France — Phone: +33 9 72 10 10 07 — www.ovhcloud.com.',
        },
        {
          type: 'p',
          content:
            'Domain name / registrar: Gandi SAS — 63-65 boulevard Masséna, 75013 Paris, France — www.gandi.net.',
        },
      ],
    },
    {
      id: 'ip',
      title: 'Intellectual property',
      blocks: [
        {
          type: 'p',
          content:
            "All elements of the openmeta.tech website (structure, source code, texts, illustrations, logos, trademarks, sounds) are protected by copyright and trademark law. Any reproduction, representation or distribution, in whole or in part, without prior written consent is strictly prohibited.",
        },
      ],
    },
    {
      id: 'data',
      title: 'Personal data',
      blocks: [
        {
          type: 'p',
          content:
            'The processing of personal data is described in our Privacy Policy, available at /confidentialite.',
        },
      ],
    },
    {
      id: 'contact',
      title: 'Contact',
      blocks: [
        {
          type: 'p',
          content:
            "For any information request or notice: support@openmeta.fr.\nOPENMETA\n5037 Chemin de la Veillotière\n61330 Ceaucé — France\nPhone: +33 2 59 16 64 45",
        },
      ],
    },
  ],
};
